import { connect } from 'react-redux';

import UpgradeSiteViewerVersionModal from './upgrade_site_viewer_version_modal.jsx';

import map from 'lodash/map';
import find from 'lodash/find';
import groupBy from 'lodash/groupBy';

import {
  getPageThemeUuid
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  getIsDraft,
  getSaveStatus,
  getIsLoadingThemes,
  getCompatibleThemesForLatestUpgrade
} from 'zoomforth_codesbane_editor/reducers/index.js';

import {
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';

import {
  fetchStylePresetMappingMeta
} from 'zoomforth_codesbane_editor/action_creators/theme.js';

import {
  publish,
  viewPage
} from 'zoomforth_codesbane_editor/action_creators/misc.js';

import {
  upgradeSiteViewerVersion,
  dismissUpgradeSiteViewerVersion
} from 'zoomforth_codesbane_editor/action_creators/site_viewer_version.js';

import {
  LATEST_SITE_VIEWER_VERSION,
  getSiteViewerVersionIntro,
  getSiteViewerVersionDescription
} from 'sites_const_shared/site_viewer_versions.js';

import {
  getThemeEditorUrl
} from 'zoomforth_codesbane_editor/lib/themes.js';

import { get as getUser } from 'zoomforth_zf/appglobals/user.js';
import { get as getPages } from 'zoomforth_zf/appglobals/pages.js';

const mapStateToProps = (state) => {
  const siteViewerVersionIntro = getSiteViewerVersionIntro(LATEST_SITE_VIEWER_VERSION);
  const siteViewerVersionDescription = getSiteViewerVersionDescription(LATEST_SITE_VIEWER_VERSION);

  const isLoadingThemes = getIsLoadingThemes(state);
  const currentThemeUuid = getPageThemeUuid(state);

  const pagesByThemeUuid = groupBy(getPages().models, (pageModel)=> {
    return pageModel.get('theme_uuid');
  });

  const compatibleThemes = getCompatibleThemesForLatestUpgrade(state);
  const isCurrentThemeCompatibleForUpgrade = !!find(compatibleThemes, ['uuid', currentThemeUuid]);

  const compatibleThemesWithMeta = map(compatibleThemes, (theme)=> {
    const pagesUsingTheme = pagesByThemeUuid[theme.uuid] || [];
    const pageWithScreenshot = find(pagesUsingTheme, (page)=> {
      return page.get('screenshot_thumbnail');
    });

    var screenshotUrl;

    if (pageWithScreenshot) {
      screenshotUrl = pageWithScreenshot.get('screenshot_thumbnail');
    }

    return { ...theme, screenshotUrl, pagesUsingTheme: pagesUsingTheme.length };
  });

  const canEditThemes = getUser().getPermissions().canEditThemes();
  const currentThemeEditorUrl = canEditThemes ? getThemeEditorUrl(currentThemeUuid) : null;

  const isDraft = getIsDraft(state);
  const saveStatus = getSaveStatus(state);
  const isPublishAvailable = isDraft || saveStatus !== 'saved';

  return {
    currentThemeUuid,
    currentThemeEditorUrl,
    siteViewerVersionIntro,
    siteViewerVersionDescription,
    isLoadingThemes,
    isCurrentThemeCompatibleForUpgrade,
    isPublishAvailable,
    compatibleThemes: compatibleThemesWithMeta
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRequestClose: ()=> {
      dispatch(closeModal());
    },
    onPreviewClick: (themeUuid)=> {
      dispatch(viewPage({
        forcePreview: true,
        themeUuid: themeUuid,
        siteViewerVersion: LATEST_SITE_VIEWER_VERSION
      }));
    },
    onThemeSelect: (themeUuid, { onSuccess })=> {
      dispatch(fetchStylePresetMappingMeta(themeUuid, { onSuccess }));
    },
    onPublishClick: ()=> {
      dispatch(publish());
    },
    onUpgradeClick: (themeUuid, mappedStylePresets)=> {
      dispatch(upgradeSiteViewerVersion(themeUuid, mappedStylePresets));
    },
    onDismissClick: ()=> {
      dispatch(closeModal());
      dispatch(dismissUpgradeSiteViewerVersion());
    }
  };
};

const UpgradeSiteViewerVersionModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(UpgradeSiteViewerVersionModal);

UpgradeSiteViewerVersionModalContainer.editorModalName = 'UpgradeSiteViewerVersionModalContainer';

export default UpgradeSiteViewerVersionModalContainer;
